// Map of known base names (instance description) to translation keys
export const InstanceNameMapToKey = {
  'Bacon Cooler': 'bacon_cooler',
  'Beverage Reach-in Cooler': 'beverage_reach_in_cooler',
  'Beverage Reach-in Cooler PUW': 'beverage_reach_in_cooler_puw',
  'Breading Station': 'breading_station',
  'Bun Freezer': 'bun_freezer',
  'Counter Reach-in Cooler': 'counter_reach_in_cooler',
  'Dining Room': 'dining_room',
  'Fry Station Freezer': 'fry_station_freezer',
  'Fry Station Spa Cooler': 'fry_station_spa_cooler',
  'Kitchen Temperature': 'kitchen_temperature',
  'Meat Well Cooler': 'meat_well_cooler',
  'Outdoor Temperature': 'outdoor_temperature',
  'Outside Bun Freezer Door Magnetic Field': 'outside_bun_freezer_door_magnetic_field',
  'PUW Station': 'puw_station',
  'Salad Reach-in Cooler PUW': 'salad_reach_in_cooler_puw',
  'SL-FR Reach-in Cooler': 'sl_fr_reach_in_cooler',
  'SL-PUW Reach-in Cooler': 'sl_puw_reach_in_cooler',
  'Upright Reach-in Cooler': 'upright_reach_in_cooler',
  'Upright Reach-in Freezer': 'upright_reach_in_freezer',
  'Upright Freezer': 'upright_freezer',
  'Walk-in Cooler': 'walk_in_cooler',
  'Walk-in Cooler Door Magnetic Field': 'walk_in_cooler_door_magnetic_field',
  'Walk-in Freezer': 'walk_in_freezer',
  'Walk-in Freezer Door Magnetic Field': 'walk_in_freezer_door_magnetic_field',
} as const;

// Mapping for specific descriptions to new values
export const DescriptionMapping = {
  'Beverage Reach-in Cooler PUW': 'PUW Station',
  'Dining Room Temperature': 'Dining Room',
  'Upright Reach-in Freezer II': 'Upright Freezer',
  'Upright Reach-in Freezer III': 'Upright Freezer 2',
  'Walk-in Cooler Door Magnetic Field': 'Walk-in Cooler Door',
  'Walk-in Freezer Door Magnetic Field': 'Walk-in Freezer Door',
} as const;

export class EquipmentName {
  name?: string;
  suffix?: string;

  constructor(_value?: string) {
    if (!_value) return;

    const mappedDescription = DescriptionMapping[_value as keyof typeof DescriptionMapping] || _value;
    const matchEntry = Object.entries(InstanceNameMapToKey).find(([base]) => {
      const regex = new RegExp(`^(${base})(\\s.+)?$`, 'i');
      return regex.test(mappedDescription);
    });

    if (matchEntry) {
      const [base, key] = matchEntry;
      const regex = new RegExp(`^(${base})(\\s.+)?$`, 'i');
      const match = mappedDescription.match(regex);
      const suffix = match?.[2]?.trim() || '';

      this.name = key;
      this.suffix = suffix;
    }
  }
}
